import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useAuth } from "../../../context/API_Client";
import BoxPayAutoComplete from "./CurrencyDropdown";
import CountryList from "./CountryDropdown";
import CustomButton from "../../../reusableComponents/CustomButton";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import LoadingLogoPage from "../../loadingPage/loadingPage";
import { sortArrayValue } from "../../utils/utils";
import IOSSwitch from "../../checkout/IOSSwitch";
import { colorBrandObject } from "../../../../constants/brandings";

const ConfigurePaymentGateways = (props) => {
  const {
    getPspConfigSchemas,
    getAllPspConfigs,
    getCountryNames,
    getBusinessUnits,
  } = useAuth();
  const [pspWiseSchema, setPspWiseSchema] = useState({});
  const [pspCreds, setPspCreds] = useState({});
  const pspsToConfigure = props.pspsToConfigure;
  const [openCC, setOpenCC] = useState(false);
  const [saved, setSaved] = useState(true);

  const isFirstRender = useRef(true);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [chooseCountry, setChooseCountry] = useState([]);
  const [chooseCurrencies, setChooseCurrencies] = useState([]);
  const [countryData, setCountryData] = useState([]);

  const [filledIndexes, setFilledIndexes] = useState(0);
  const handleOpenCC = () => {
    setOpenCC(true);
  };

  const handleCloseCC = () => {
    setOpenCC(false);
  };

  const handleSave = () => {
    props.setUnSaved(true);
    setSaved(false);
    props.gatewayCredsHandler(pspCreds);
    props.setCountrySelected(chooseCountry);
    props.setCurrenciesSelected(chooseCurrencies);

    // sessionStorage.setItem("storeCreds", JSON.stringify(props.storeCreds));

    props.getSupportedMethods();
  };
  const [businessUnitOptions, setBusinessUnitOptions] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState([]);
  const [allBusinessUnits, setAllBusinessunits] = useState([]);
  const [gotValue, setGotValue] = useState(false);
  const [selectedEnv, setSelectedEnv] = useState("");
  useEffect(() => {
    let envName = window.location.hostname.split(".")[0].toString();
    if (envName.includes("-")) {
      envName = envName.split("-")[0];
    }
    setSelectedEnv(envName);
  }, []);

  const handleCancel = () => {
    if (props.unSaved === false) handleOpenCC();
    else props.handleToggleOff();
  };

  const handleUnitSelect = (pspCode, value, index) => {
    let store;
    let present = false;
    setSelectedBusinessUnit((previousCreds) => {
      const newCreds = { ...previousCreds };
      if (newCreds[index] === undefined) newCreds[index] = {};
      else {
        store = newCreds[index];
        present = true;
      }
      newCreds[index] = value;
      return newCreds;
    });
    if (!present) {
      setBusinessUnitOptions((options) =>
        options.filter((ele) => ele?.code !== value?.code)
      );
    } else {
      let arr = businessUnitOptions;
      if (store) {
        arr.push({
          code: store?.code,
          name: store?.name,
        });
        setBusinessUnitOptions(arr);
      }
      if (value !== null) {
        setBusinessUnitOptions((options) =>
          options.filter((ele) => ele?.code !== value?.code)
        );
      }
    }
    pspCredChangeHandler(pspCode, "BusinessUnit", value?.code, index);
  };

  useEffect(() => {
    getPspConfigSchemas(
      pspsToConfigure?.map((psp) => psp.value),
      (pspCode, pspSchema) => {
        setPspWiseSchema((previousSchemas) => {
          const newSchema = {};
          newSchema[pspCode] = pspSchema;
          return newSchema;
        });
      }
    );

    getAllPspConfigs((data) => {
      if (data) {
        data.map((pspValue) => {
          if (
            pspValue?.pspCode === pspsToConfigure[0]?.value &&
            pspValue?.currencyCodes
          ) {
            let arr = [];

            const sortedCurrencyCodes = sortArrayValue(pspValue.currencyCodes);




            sortedCurrencyCodes.map((obj, index) =>
              arr.push({
                name: obj,
                currencyCode: obj,
                id: index,
              })
            );
            setCurrencyOptions(arr);
          }
        });
      }
    });

    getCountryNames(
      function (data) {
        setCountryData(data);
      },
      function (errorMsg) { }
    );

    let ar = [];
    getBusinessUnits(
      function (data) {
        setAllBusinessunits(data);
        const creds = sessionStorage.getItem("storeCreds");
        const getCreds = JSON.parse(creds);
        const newSelectedBusinessUnits = [];

        for (let i = 0; i < data.length; i++) {
          let found = false;

          if (sessionStorage.getItem("storeCreds")) {
            for (let j = 0; j < getCreds.length; j++) {
              if (getCreds[j].pspCode === props.value) {
                let index = 1;
                while (getCreds[j].pspCreds[props.value]?.BusinessUnit[index]) {
                  if (
                    data[i]?.code ===
                    getCreds[j].pspCreds[props.value]?.BusinessUnit[index]
                  ) {
                    found = true;
                    const value = {
                      code: data[i]?.code,
                      name: data[i]?.name,
                    };

                    if (!newSelectedBusinessUnits[index]) {
                      newSelectedBusinessUnits[index] = {};
                    }
                    newSelectedBusinessUnits[index] = value;
                    setGotValue(true);
                  }
                  index = index + 1;
                }
              }
            }
          }
          if (!found) {
            ar.push({
              code: data[i]?.code,
              name: data[i]?.name,
            });
          }
        }
        setSelectedBusinessUnit((previousCreds) => [
          ...previousCreds.slice(0, newSelectedBusinessUnits.length),
          ...newSelectedBusinessUnits,
        ]);
        setBusinessUnitOptions(ar);
      },
      function (errorMsg) { }
    );
  }, [props.filteredGateways]);

  useEffect(() => {
    let arr = [];
    getAllPspConfigs((data) => {
      if (data) {
        data.map((pspValue) => {
          if (
            pspValue?.pspCode === pspsToConfigure[0]?.value &&
            pspValue.countryCodes
          ) {
            pspValue.countryCodes.map((obj, index) =>
              arr.push({
                name: countryData[obj],
                countryCode: obj,
                id: index,
              })
            );
          }
        });
      }
    });
    setCountryOptions(arr);
  }, [countryData, props.filteredGateways]);

  useEffect(() => {
    const creds = sessionStorage.getItem("storeCreds");
    const getCreds = JSON.parse(creds);

    if (sessionStorage.getItem("storeCreds")) {
      for (let i = 0; i < getCreds.length; i++) {
        if (getCreds[i].pspCode === props.value) {
          setPspCreds(getCreds[i].pspCreds);
          if (getCreds[i]?.pspCreds[props.value])
            setFilledIndexes(
              Object.keys(getCreds[i]?.pspCreds[props.value]["BusinessUnit"])
                .length
            );
          setChooseCountry(getCreds[i]?.chooseCountry);
          setChooseCurrencies(getCreds[i]?.chooseCurrencies);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const data = [
      {
        pspCode: props.value,
        pspCreds: pspCreds,
        chooseCountry: chooseCountry,
        chooseCurrencies: chooseCurrencies,
      },
    ];

    if (!props.storeCreds.find((ele) => ele.pspCode === data[0].pspCode)) {
      const newdata = [...props.storeCreds, ...data];
      props.setStoreCreds(newdata);
    } else {
      const arr = props.storeCreds.filter((v) => v.pspCode !== data[0].pspCode);

      const newdata = [...arr, ...data];
      props.setStoreCreds(newdata);
    }
  }, [pspCreds, chooseCountry, chooseCurrencies]);

  useEffect(() => {
    if (saved === false) {
      props.setUnSaved(false);
    }
  }, [saved]);

  const checkForErrors = () => {
    let errorFound = false;
    Object.keys(pspWiseSchema).forEach((pspCode) => {
      const propertiesSchema = pspWiseSchema[pspCode].configs.properties;

      const allCredentials = {
        ...propertiesSchema,
      };
      const properties = allCredentials;
      Object.keys(properties).forEach((fieldName) => {
        for (let i = 1; i <= count.length; i++) {
          if (
            getFieldValue(pspCode, fieldName, i) === undefined &&
            (properties[fieldName].minLength > 0 ||
              fieldName === "BusinessUnit")
          ) {
            errorFound = true;
          }
        }
      });
    });

    return errorFound;
  };

  const getFieldValue = (pspCode, fieldName, index) => {
    if (
      pspCreds[pspCode] &&
      pspCreds[pspCode][fieldName] &&
      pspCreds[pspCode][fieldName][index]
    )
      return pspCreds[pspCode] &&
        pspCreds[pspCode][fieldName] &&
        pspCreds[pspCode][fieldName][index]
        ? pspCreds[pspCode][fieldName][index]
        : "";
  };

  const pspCredChangeHandler = (pspCode, credName, credValue, index) => {
    setPspCreds((previousCreds) => {
      const newCreds = { ...previousCreds };

      if (!newCreds[pspCode]) {
        newCreds[pspCode] = {};
      }

      if (!newCreds[pspCode][credName]) {
        newCreds[pspCode][credName] = {};
      }

      newCreds[pspCode][credName][index] = credValue;

      return newCreds;
    });
  };

  const [count, setCount] = useState([1]);

  const updateCount = () => {
    const newCount = [...count, count.length + 1];
    setCount(newCount);
    setSaved(true);
  };

  function getSortedKeys(obj) {
    const requiredKeys = [];
    const booleanKeys = [];
    const maxKeys = [];
    const otherKeys = [];

    Object.entries(obj).forEach(([key, value]) => {
      if (value.minLength > 0 && !value.maximum) {
        requiredKeys.push(key);
      } else if (value.type === "boolean") {
        booleanKeys.push(key);
      } else if (value.maximum >= 500) {
        maxKeys.push(key);
      } else {
        otherKeys.push(key);
      }
    });
    return [...requiredKeys, ...booleanKeys, ...maxKeys, ...otherKeys];
  }

  const [mobileLayout, setMobileLayout] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1500px)");
    setMobileLayout(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setMobileLayout(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  return (
    <>
      <div style={{ marginTop: "-10px" }}>
        <Alert
          sx={{
            width: "92%",
            fontSize: "12px",
            backgroundColor: "#FEFFE6",
            marginBottom: "20px",
            marginLeft: "6%",
          }}
          icon={false}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <img
              src="/assets/info-circle-yellow.svg"
              style={{ paddingRight: "6px", paddingTop: "2px" }}
            />
            <div>
              <span
                style={{
                  color: "black",
                  fontFamily: "Poppins",
                  paddingRight: "-10px",
                }}
              >
                Please procure the credentials required from your respective
                payment gateways before enabling it on our dashboard and make
                sure you are entering the credentials for the
              </span>
              <span
                style={{
                  fontWeight: "bold",
                }}
              >
                {" " + selectedEnv + " environment"}
              </span>
            </div>
          </div>
        </Alert>
      </div>
      <div
        style={{
          height: mobileLayout ? "36vh" : "42vh",
          overflowY: "auto",
          width: "100%",
          padding: "60px 12px 9px 40px",
        }}
      >
        <section
          style={{
            border: "1.2px",
            borderStyle: "solid",
            borderColor: "#C2C2C2",
            borderRadius: "5px",
            backgroundColor: "white",
            width: "100%",
            paddingTop: "20px",
            paddingLeft: "20px",
            paddingRight: "20px",
            minHeight: mobileLayout ? "35vh" : "25vh",
            marginTop: "-60px",
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              width: !mobileLayout ? "47%" : "100%",
            }}
          >
            <FormLabel style={{ fontSize: "0.78rem" }} required={true}>
              Business Unit
            </FormLabel>
            <Tooltip
              title="A Business Unit represents a distinct division or region within our organization."
              placement="right"
            >
              <IconButton>
                <img src="/assets/info.svg" style={{ height: "16px" }} />
              </IconButton>
            </Tooltip>
            <Autocomplete
              multiple={false}
              options={businessUnitOptions}
              getOptionLabel={(option) => option?.name}
              renderOption={(props, option, { selected }) => (
                <li {...props}>{option?.name}</li>
              )}
              isOptionEqualToValue={(option, value) =>
                option?.name === value?.name
              }
              value={
                selectedBusinessUnit[1]
                  ? selectedBusinessUnit[1]
                  : gotValue
                    ? selectedBusinessUnit[1]
                    : null
              }
              onChange={(e, newValue) =>
                handleUnitSelect(props.value, newValue, 1)
              }

              renderTags={() => null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: '180px',
                  overflowY: 'auto',
                },
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: mobileLayout ? "column" : "row",
              width: "100%",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: mobileLayout ? "100%" : "47%",
                marginBottom: "20px",
                marginRight: "5%",
              }}
            >
              <FormLabel style={{ fontSize: "0.78rem" }} required={true}>
                Country
              </FormLabel>
              <Tooltip
                title="Countries indicate the specific regions from which you wish to receive payments."
                placement="right"
              >
                <IconButton>
                  <img src="/assets/info.svg" style={{ height: "16px" }} />
                </IconButton>
              </Tooltip>

              <CountryList
                options={countryOptions}
                countrySelected={chooseCountry}
                setCountrySelected={setChooseCountry}
                value={props.value}
                unSaved={props.unSaved}
              />
            </div>

            <div
              style={{
                width: mobileLayout ? "100%" : "47%",
              }}
            >
              <FormLabel style={{ fontSize: "0.78rem" }} required={true}>
                Currencies
              </FormLabel>
              <Tooltip
                title="Currencies represent the specific monetary units you want to support."
                placement="right"
              >
                <IconButton>
                  <img src="/assets/info.svg" style={{ height: "16px" }} />
                </IconButton>
              </Tooltip>
              <BoxPayAutoComplete
                options={currencyOptions}
                currenciesSelected={chooseCurrencies}
                setCurrenciesSelected={setChooseCurrencies}
                value={props.value}
                unSaved={props.unSaved}
              />
            </div>
          </div>
        </section>
        {count.map((index) => {
          return (
            <div key={index} style={{ marginTop: "20px" }}>
              <section
                style={{
                  border: "1.2px",
                  borderStyle: "solid",
                  borderColor: "#C2C2C2",
                  borderRadius: "5px",
                  backgroundColor: "white",
                  width: "100%",
                  height: "60%",
                  padding: "18px 5px 15px 25px",
                }}
              >
                {Object.keys(pspWiseSchema).map((pspCode) => {
                  const credentials = pspWiseSchema[pspCode].configs.properties;
                  const allCredentials = {
                    ...credentials,
                  };
                  const properties = allCredentials
                  const schemaKeys = getSortedKeys(allCredentials);
                  return (
                    <div>
                      <Typography
                        className="font-black-highest"
                        style={{
                          marginBottom: "20px",
                          color: "#403E9F",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        Enter Credentials
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        key={pspCode + "-form-container" + index}
                      >
                        {schemaKeys.map((fieldName) => (

                          <Grid
                            item
                            xs={
                              mobileLayout ||
                                properties[fieldName]?.maximum >= 500
                                ? 12
                                : 6
                            }
                          // sx={{
                          //   order:
                          //     properties[fieldName]?.maximum >= 500
                          //       ? 1000
                          //       : "",
                          // }}
                          >
                            <FormControl
                              sx={{ marginBottom: 5, width: "100%" }}
                              key={pspCode + fieldName}
                              required={
                                properties[fieldName].minLength > 0 ||
                                fieldName === "BusinessUnit"
                              }
                            >
                              <FormLabel style={{ fontSize: "0.78rem" }}>
                                {properties[fieldName].title}
                              </FormLabel>

                              {fieldName === "BusinessUnit" ? (
                                <div
                                  style={{
                                    width: mobileLayout ? "95%" : "90%",
                                  }}
                                >
                                  <Autocomplete
                                    multiple={false}
                                    options={businessUnitOptions}
                                    disabled={
                                      !props.unSaved && index <= filledIndexes
                                    }
                                    getOptionLabel={(option) => option?.name}
                                    renderOption={(
                                      props,
                                      option,
                                      { selected }
                                    ) => <li {...props}>{option?.name}</li>}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.name === value?.name
                                    }
                                    value={
                                      selectedBusinessUnit[index]
                                        ? selectedBusinessUnit[index]
                                        : gotValue
                                          ? selectedBusinessUnit[index]
                                          : null
                                    }
                                    onChange={(e, newValue) =>
                                      handleUnitSelect(pspCode, newValue, index)
                                    }
                                    renderTags={() => null}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select"
                                      />
                                    )}
                                  />
                                </div>
                              ) : properties[fieldName].type == "boolean" ? <>
                                <IOSSwitch
                                  sx={{
                                    m: 1, "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "white"
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                      backgroundColor: colorBrandObject?.secondaryButtonColor,
                                    },
                                  }}
                                  onChange={(e) =>
                                    pspCredChangeHandler(
                                      pspCode,
                                      fieldName,
                                      e.target.checked,
                                      index
                                    )
                                  }
                                  checked={getFieldValue(
                                    pspCode,
                                    fieldName,
                                    index
                                  )}
                                />
                              </> : properties[fieldName]?.maximum >= 500 ? (
                                <textarea
                                  style={{
                                    width: "100%",
                                    height: "100px",
                                    resize: "none",
                                  }}
                                  value={getFieldValue(
                                    pspCode,
                                    fieldName,
                                    index
                                  )}
                                  onChange={(e) =>
                                    pspCredChangeHandler(
                                      pspCode,
                                      fieldName,
                                      e.target.value,
                                      index
                                    )
                                  }
                                />
                              ) : (
                                <TextField
                                  sx={{
                                    width: "100%",
                                    height: 40,
                                    "& .MuiInputBase-root": {
                                      width: "100%",
                                    },
                                  }}
                                  value={getFieldValue(
                                    pspCode,
                                    fieldName,
                                    index
                                  )}
                                  onChange={(e) =>
                                    pspCredChangeHandler(
                                      pspCode,
                                      fieldName,
                                      e.target.value,
                                      index
                                    )
                                  }
                                />
                              )}
                            </FormControl>
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  );
                })}
              </section>
            </div>
          );
        })}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        ></div>

        <SmallModal
          toggleDialog={openCC}
          headerText={"Cancel Gateway"}
          subHeaderText={
            "Are you sure you want to cancel in between? Your credentials for the current gateway will be lost"
          }
          outlinedBtnText={"No"}
          outlinedBtnFunction={handleCloseCC}
          filledBtnText={"Yes"}
          filledBtnFunction={props.handleYes}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          position: "relative",
          bottom: "-10px",
          paddingRight: "20px",
        }}
      >
        <div style={{ paddingRight: "20px" }}>
          <CustomButton
            text={"Cancel"}
            type={"primary"}
            size={"sm"}
            onClick={handleCancel}
          />
        </div>
        <CustomButton
          text={"Save"}
          type={"primary"}
          size={"sm"}
          variant={"contained"}
          onClick={handleSave}
          disabled={
            chooseCountry === null ||
            chooseCurrencies.length == 0 ||
            (selectedBusinessUnit[1] === undefined && checkForErrors())
          }
        />
      </div>
    </>
  );
};

export default ConfigurePaymentGateways;

const count = [1];
